import React from "react";
import styled, { keyframes } from "styled-components";

interface LoaderProps {
  size?: number; // Размер ширины и высоты
  thickness?: number; // Толщина обводки
  color?: string; // Цвет обводки
}

const LoaderCircle: React.FC<LoaderProps> = ({
  size = 20,
  thickness = 3,
  color = "green",
}) => {
  return <Loader size={size} thickness={thickness} color={color} />;
};

export default LoaderCircle;

// Анимация вращения
const rotation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

// Стили для лоадера
const Loader = styled.div<LoaderProps>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border: ${(props) => props.thickness}px dotted ${(props) => props.color};
  border-radius: 50%;
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  animation: ${rotation} 2s linear infinite;
`;